import CurrencyFormat from 'react-number-format';
import { Card, CardBody, Col, Row } from 'reactstrap';

import { useInvestmentNoteDispatch } from '../../../contexts/InvestmentNoteContext';
import { useDict } from '../../../contexts/LanguageContext';
import { RepaymentType } from '../../../utils/constants';
import { dateFormatter } from '../../../utils/dateHelper';

const CompletedInvestmentNoteCardList = (props) => {
    const {
        investmentNotes,
        doTermLoanModal = () => null,
        onShowComment = () => null,
    } = props;

    const dict = useDict();

    const investmentNoteDispatch = useInvestmentNoteDispatch();

    if (investmentNotes.length > 0) {
        return (
            <>
                {investmentNotes.map((note) => (
                    <Card
                        style={{ marginBottom: 20 }}
                        key={note.id}
                    >
                        <CardBody style={{ padding: 20 }}>
                            <Row className="align-items-center mb-2 g-0">
                                <h4
                                    onClick={() => investmentNoteDispatch({ type: 'viewInvestmentNoteDetails', investmentNote: note })}
                                    style={{
                                        backgroundColor: '#ffffff',
                                        border: 'none',
                                        color: '#226EF4',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',
                                        textUnderlineOffset: '3px',
                                    }}
                                    className="mr-2"
                                    aria-hidden
                                >
                                    <u>{note.name}</u>
                                </h4>
                                {/* {note.comments.length > 0 && (
                                    <span
                                        onClick={() => onShowComment(note)}
                                        aria-hidden
                                        role="button"
                                        tabIndex={0}
                                        style={{ width: '24px' }}
                                    >
                                        <img
                                            src={AnnouncementIcon}
                                            alt="announcement"
                                        />
                                    </span>
                                )} */}
                            </Row>
                            {/* <Row
                                className="mb-2 g-0"
                                style={{ rowGap: '4px' }}
                            >
                                <div
                                    key={note.theme.id}
                                    className="invest-now-badge w-auto"
                                >
                                    {note.theme[appendLocale('name')]}
                                </div>
                            </Row>
                            <Row className="mb-1 g-0">
                                <h5 className="color-grey shortLongText2">
                                    {note.description}
                                </h5>
                            </Row> */}
                            <Row>
                                <Col md={6} sm={12}>
                                    <Row>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="text-return bold-text"
                                        >
                                            {dict.netReturn}
                                        </Col>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="text-return text-right"
                                        >
                                            {parseFloat(
                                                note.net_return_rate
                                            ).toFixed(1)}{' '}
                                            %{' '}
                                            {dict.pa}
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col
                                            md={7}
                                            sm={12}
                                            xs={6}
                                            className="text-return bold-text"
                                        >
                                            {dict.disbursementDate}
                                        </Col>
                                        <Col
                                            md={5}
                                            sm={12}
                                            xs={6}
                                            className="text-return text-right"
                                        >
                                            {note.disbursement_date ? dateFormatter(note.disbursement_date) : null}
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="text-capitalize bold-text"
                                        >
                                            {dict.investedAmount}
                                        </Col>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="text-right"
                                        >
                                            <CurrencyFormat
                                                value={parseFloat(
                                                    note.invest_amount
                                                ).toFixed(2)}
                                                displayType="text"
                                                thousandSeparator
                                                prefix="฿ "
                                            />
                                        </Col>
                                    </Row>

                                    {note.issuer_name && (
                                        <Row>
                                            <Col
                                                md={5}
                                                sm={12}
                                                xs={5}
                                                className="bold-text"
                                            >
                                                {dict.issuer}
                                            </Col>
                                            <Col
                                                md={7}
                                                sm={12}
                                                xs={7}
                                                className="text-right"
                                            >
                                                {note.issuer_name}
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                                <Col md={6} sm={12}>
                                    {/* Will not display tenure for notes since its all invoices */}
                                    {note.repaymentType ===
                                        RepaymentType.InstalmentRepayment && (
                                            <Row>
                                                <Col
                                                    md={6}
                                                    sm={12}
                                                    xs={6}
                                                    className="bold-text"
                                                >
                                                    {dict.tenure}
                                                </Col>
                                                <Col
                                                    md={6}
                                                    sm={12}
                                                    xs={6}
                                                    className="text-right"
                                                >
                                                    {note.tenure_days} {dict.days}
                                                </Col>
                                            </Row>
                                        )}
                                    <Row>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="bold-text"
                                        >
                                            {note.recovered_date === null || note.recovered_date === undefined
                                                ? dict.settlementDate
                                                : dict.recoveredDate}
                                        </Col>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="text-right"
                                        >
                                            {note.recovered_date === null || note.recovered_date === undefined
                                                ? dateFormatter(note.maturity_date)
                                                : dateFormatter(note.recovered_date)}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="bold-text"
                                        >
                                            {note.recovered_amount === null || note.recovered_amount === undefined
                                                ? dict.netReturnAmount
                                                : dict.recoveredAmount}
                                        </Col>
                                        <Col
                                            md={6}
                                            sm={12}
                                            xs={6}
                                            className="text-right"
                                        >
                                            <CurrencyFormat
                                                value={parseFloat(
                                                    note.recovered_amount === null || note.recovered_amount === undefined
                                                        ? note.net_return_amount
                                                        : note.recovered_amount
                                                ).toFixed(2)}
                                                displayType="text"
                                                thousandSeparator
                                                prefix="฿ "
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {/* {note.repaymentType ===
                                RepaymentType.InstalmentRepayment && (
                                    <Row
                                        className="d-flex justify-content-center g-0"
                                    >
                                        <Button
                                            outline
                                            className="btn-outline-primary mb-0 mt-3 rounded w-xs-70 w-sm-50 w-md-30"
                                            color="primary"
                                            onClick={() => doTermLoanModal(note)}
                                        >
                                            {dict.repayments}
                                        </Button>
                                    </Row>
                                )} */}
                        </CardBody>
                    </Card>
                ))}
            </>
        );
    }

    return null;
};

export default CompletedInvestmentNoteCardList;
